<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">采编一体化</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="threediv">
          网站账号开通及试用可联系我们公司驻当地分公司业务人员
        </div>
        <div class="twodiv link"  @click="toCaiBian()">
            <span> http://caifang.ytzhihui.com/#/reprintList</span>
        </div>
        <div class="threediv link" @click="toBianMu()">
          <span>http://automarc.ytzhihui.com/login.html</span>
        </div>
        <div class="threediv">
          田田网是拥有自主知识产权，集版权控制、纸电新书发布、图书馆采购与读者借阅、荐购服务、PDA实体采购为一体，专业面向图书馆的中文图书纸电同步平台。平台的内容仍由出版方提供，平台专注于为出版方、馆配商、图书馆搭建信息对接的桥梁，提供资源整合、信息推送、买卖交易等各种服务，意在建立一个图书馆和出版社之间的信息高速公路。
        </div>
        <div class="threediv">
          其中采编一体化是该平台的核心系统，采编一体化通过智能数据采集技术，源源不断的实时给书目资源库注入最新的书目信息，基于三新强大的全书目资源库，通过采购门户智能查找并收订书目，收订过程中同步推送给自动编目工具，保证采购和编目工作可同步进行，能最大程度缩短采购行为在系统中的数据流转周期，便于管理。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  import Cookies from 'js-cookie'
  import {Base64} from 'js-base64'

  export default {
    name: 'ProductCiaabian',
    data() {
      return {
        activeName: 'first'
      }
    },
    mounted() {
    },
    methods: {
      toCaiBian(){
        if(Cookies.get('passPort') && Cookies.get('passWord')){
          window.open(`http://caifang.ytzhihui.com/login.html?passPort=${Cookies.get('passPort')}&orgGid=${Cookies.get('orgGid')}&passWord=${Base64.encode(Cookies.get('passWord'))}`);
        }else{
           window.open(`http://caifang.ytzhihui.com/#/reprintList`)
        }
      },
      toBianMu(){
        if(Cookies.get('passPort') && Cookies.get('passWord')){
          window.open(`http://automarc.ytzhihui.com/login.html?passPort=${Cookies.get('passPort')}&orgGid=${Cookies.get('orgGid')}&passWord=${Base64.encode(Cookies.get('passWord'))}`);
        }else{
           window.open(`http://automarc.ytzhihui.com/login.html`)
        }
      },
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
    &.link{
      span{
         cursor: pointer;
        text-decoration: underline;
       }
    }
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
    &.link{
      span{
         cursor: pointer;
        text-decoration: underline;
       }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Ciaabian.vue